import { useCallback, useMemo } from 'react';
import {
  McAvatar,
  McList,
  McListItem,
  McMenu,
  McThemeSwitch,
  McTopBar,
} from '@maersk-global/mds-react-wrapper';

import useThemeContext from '../hooks/contexts/useThemeContext';
import useUserSessionContext from '../hooks/contexts/useUserSessionContext';

const AppTopBar = () => {
  const { toggleThemeVariant } = useThemeContext();
  const { userSession, logout } = useUserSessionContext();

  const userInitials = useMemo(() => {
    const name = (userSession?.name ?? '').trim();

    return name
      ? name
          .trim()
          .split(/\s+/)
          .map((word) => word[0].toUpperCase())
          .join('')
      : '';
  }, [userSession]);

  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  if (!userSession) {
    return null;
  }

  return (
    <McTopBar product="TMS Operations Hub" productshort="MTMS">
      <div slot="actions">
        <McThemeSwitch change={toggleThemeVariant} />

        <McMenu position="bottom-center">
          <McAvatar
            appearance="color-3"
            fit="small"
            hiddentooltip
            info={userSession.name}
            initials={userInitials}
            slot="trigger"
            style={{ cursor: 'pointer' }}
          ></McAvatar>

          <McList>
            <McListItem label="Logout" onClick={handleLogout}></McListItem>
          </McList>
        </McMenu>
      </div>
    </McTopBar>
  );
};

export default AppTopBar;
